import { bludeltaRequest, BluDeltaResponse } from './network';
import { Cache } from 'lib/Cache';

export interface MandatorsResponse extends BluDeltaResponse {
  ApiKey: {
    Name: string;
    Key: string;
  };
  Clients: {
    Name: string;
    Id: string;
  }[];
}
const clientCache = new Cache(1);
/**
 * If the user is logged on with access rights for multiple mandators,
 * he has to select one single mandator before he can upload the documents.
 * This is required because an invoice container always needs to be assigned
 * to one specific mandator.
 *
 * After a unique pair of `ApiKey` and `ApiIdentifier` has been selected, the
 * document can be uploaded. See: `uploadInvoiceContainer` API call.
 */
export async function getMandators() {
  const cachedClients = clientCache.get('clients');
  if (cachedClients) return cachedClients;
  // const res = await bludeltaRequest('GET', '/clients');
  const res = await bludeltaRequest('GET', '/clientMasterData');
  (res as MandatorsResponse).Clients.sort((a, b) => {
    if (a.Name < b.Name) return -1;
    if (a.Name > b.Name) return 1;
    else return 0;
  });
  clientCache.set('clients', res);
  return res;
}
